// extracted by mini-css-extract-plugin
module.exports = {"Small":"style_Small__2vuEr","unchecked":"style_unchecked__xqJHl","checked":"style_checked__U8Bhv","indeterminate":"style_indeterminate__JRi87","disabled":"style_disabled__ptnnq"};